/* eslint-disable */
<template>
  <div class="cases">
    <AdminNavigation ref="navigation" indexProps="2" />
    <div class="top-panel">
      <Header />
      <div class="header-title-section">
        <div class="header-title"><h1>Cases ({{totalCount}})</h1></div>
        <div class="header-sub-title">Click to view the case, or add a booking.</div>
      </div>
    </div>
    <div class="panel">
      <AdminClientsMenu :key="4" :indexProps="4" />
      <div class="content">
        <div class="tool-bar row">
          <div class="col">
            <div>
              <div class="d-flex align-items-center align-content-space-between w-100 flex-wrap">
                <img v-if="listParam.CaseID || listParam.ClientName || listParam.ClaimantSurname || listParam.ClaimantFirstName || listParam.ClientID || Number.isInteger(listParam.CaseStatus) || listParam.DateofBirthFrom || listParam.DateofBirthTo" class="mr-2 cursor-pointer" src="@/assets/images/close_icon.svg" @click="cancelSearch" title="Cancel Search"/>
                <el-input style="max-width: 100px" class="mr-1" @input="search()" clearable placeholder="Case ID" v-model="listParam.CaseID"/>
                <el-input style="max-width: 130px" class="mr-1" @input="search()" clearable placeholder="Client Name" v-model="listParam.ClientName"/>
                <el-input style="max-width: 180px" class="mr-1" @input="search()" clearable placeholder="Examinee Surname" v-model="listParam.ClaimantSurname"/>
                <el-input style="max-width: 190px" class="mr-1" @input="search()" clearable placeholder="Examinee First Name" v-model="listParam.ClaimantFirstName"/>
                <el-select style="width: 100px" class="mr-1" v-model="listParam.CaseStatus" placeholder="Is Active" clearable @change="selectPage(1)">
                  <el-option :value="1" label="Active">Active</el-option>
                  <el-option :value="0" label="Inactive">Inactive</el-option>
                </el-select>
                <el-date-picker
                    v-model="dateValue"
                    type="daterange"
                    style="max-width: 320px"
                    start-placeholder="Birth Date Start"
                    popper-class="date-range-picker-popper"
                    format="dd/MM/yyyy"
                    value-format="yyyy-MM-dd"
                    @change="changeDates"
                    end-placeholder="Birth Date End"
                    clearable
                />
<!--                <div class="d-flex justify-content-end flex-grow-1">-->
<!--                  <v-btn class="add-icon" dark @click="addNewCase">Add New</v-btn>-->
<!--                </div>-->
              </div>
            </div>
          </div>
        </div>

        <div v-if="fetchedData" class="content-scroll-x">
          <div>
              <el-table v-if="allCases.length > 0" @row-click="RowClick" ref="bookingTable" :default-sort="{prop: 'CaseID', order: 'descending'}" stripe @sort-change="sortParam" :data="allCases" tooltip-effect="dark" :header-row-style="{background: '#fde9eb', height: '70px'}" :header-cell-style="{fontWeight: 100}">
                <el-table-column
                    width="100"
                    prop="CaseID"
                    label="ID"
                    sortable="custom"
                    show-overflow-tooltip
                    fixed="left"
                >
                  <template slot-scope="scope">
                    <span>{{
                        scope.row.id
                      }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                    show-overflow-tooltip
                    prop="Client"
                    sortable="custom"
                    label="Client"
                >
                  <template slot-scope="scope">
                    <span>{{
                        scope.row.clientBranchName
                      }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                    width="180"
                    show-overflow-tooltip
                    prop="Claimant"
                    sortable="custom"
                    label="Examinee Name"
                >
                  <template slot-scope="scope">
                    <span>{{
                        scope.row.claimantFullName
                      }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                    width="150"
                    sortable="custom"
                    show-overflow-tooltip
                    prop="DateofBirth"
                    label="Date of Birth"
                >
                  <template slot-scope="scope">
                    <span>{{
                        formatDate(scope.row.dateOfBirth, "DD/MM/YYYY")
                      }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                    width="150"
                    show-overflow-tooltip
                    prop="nextBookingDate"
                    label="Next Booking Date"
                >
                  <template slot-scope="scope">
                    <span>{{
                        formatDate(scope.row.nextBookingDate, "DD/MM/YYYY")
                      }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                    width="180"
                    show-overflow-tooltip
                    prop="numberBookings"
                    label="Number Of Booking"
                >
                </el-table-column>
                <el-table-column
                    width="120"
                    sortable="custom"
                    show-overflow-tooltip
                    prop="CaseStatus"
                    label="Status"
                >
                  <template slot-scope="scope">
                    <span>{{Number(scope.row.caseStatus) === 1 ? 'Active' : 'InActive'}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                    width="100"
                    show-overflow-tooltip
                    prop="caseStatus"
                    label=" "
                >
                  <div class="icon-group" slot-scope="scope">
                    <router-link :to="{ name: 'admin-bookings', query: {caseId: scope.row.id} }"
                    ><img data-toggle="tooltip" data-placement="right" title="View Bookings" src="@/assets/images/calendar_dark_grey_icon.svg"
                    /></router-link>
                    <router-link v-if="Number(scope.row.caseStatus) === 1" :to="{ name: 'admin-search-specialist', query: { id: scope.row.id }}"
                    ><img data-toggle="tooltip" data-placement="right" title="Add Booking" src="@/assets/images/add_booking_dark_icon.svg"
                    /></router-link>
                    <a v-if="scope.row.zohoCaseLink" :href="scope.row.zohoCaseLink" target="_blank"><img data-toggle="tooltip" data-placement="right" title="View on Zoho" src="@/assets/images/zoho_icon.svg"/></a>
                  </div>
                </el-table-column>
              </el-table>
            <div v-else class="p-3">{{ noCaseMessage }}</div>
          </div>
        </div>

        <div v-if="totalCount > listParam.pageSize" class="pagination">
          Page
          <div class="pagination-group">
            <div class="border-icon pagination-current dropdown">
              <div class="pagination-current-text">{{ listParam.pageNum }}</div>
              <div class="pagination-current-icon" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></div>
              <div class="dropdown-menu shadow" aria-labelledby="pagination-current-icon">
                <div class="dropdown-item" v-for="item in (1, Math.ceil(totalCount/listParam.pageSize))" :class="listParam.pageNum === item ? 'selected' : ''" :value="item" :key="item" @click="selectPage(item)">
                  {{ item }}
                </div>
              </div>
            </div>
          </div>
          <div class="pagination-total">of &nbsp; {{ Math.ceil(totalCount/listParam.pageSize) }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import utilities from '@/assets/js/utilities'
  import AdminNavigation from '@/components/AdminNavigation'
  import Header from '@/components/Header'
  import AdminClientsMenu from '@/components/AdminClientsMenu'
  import { debounce } from 'lodash'
  export default {
    name: 'AdminCases',
    props: ['searchOptionProps'],
    components: {
      AdminNavigation,
      Header,
      AdminClientsMenu
    },
    data() {
      return {
        dateValue: "",
        fetchedData: false,
        hasError: false,
        successMessage: '',
        errorMessage: '',
        noCaseMessage: 'No cases found.',
        totalCount: 0,
        client: utilities.initClient(),
        cases: [],
        allCases: [],
        limit: 10,
        pagination: utilities.initPagination(),
        listParam: {
          ReferenceNumber: '',
          ClientName: '',
          ClaimantFirstName: '',
          ClaimantSurname: '',
          ClaimTypeID: null,
          CaseStatus: null,
          orderBy: 'CaseID',
          pageNum: 1,
          pageSize: 10,
          DateofBirthFrom: null,
          CaseID: '',
          DateofBirthTo: null,
          ascOrDesc: 'DESC',
        },
        byName: false,
        byType: false,
        byDate: false,
        byOwner: false,
      }
    },
    computed: {
      user() {
        return this.$store.getters['user/getUser'];
      },
    },
    methods: {
      search: debounce(function () {
        this.selectPage(1)
      }, 800),
      changeDates(v) {
        if(v) {
          this.listParam.DateofBirthFrom = v[0]
          this.listParam.DateofBirthTo = v[1]
        } else {
          this.listParam.DateofBirthFrom = null
          this.listParam.DateofBirthTo = null
        }
        this.selectPage(1)
      },
      cancelSearch() {
        this.listParam.ClientName = ""
        this.listParam.ClaimantName = ""
        this.listParam.BranchName = ""
        this.listParam.CaseStatus = null
        this.listParam.DateofBirthFrom = null
        this.listParam.DateofBirthTo = null
        this.listParam.CaseID = ""
        this.listParam.ClaimantSurname = ""
        this.listParam.ClaimantFirstName = ""
        this.dateValue= ""
        this.listParam.ReferenceNumber = ''
        this.client = utilities.initClient()
        window.history.replaceState({}, document.title, location.pathname)
        this.selectPage(1)
      },
      selectPage(index) {
        this.listParam.pageNum = index
        this.loadData()
      },
      sortParam( v ) {
        this.listParam.orderBy = v.prop
        if(v.order === "ascending") {
          this.listParam.ascOrDesc = 'ASC'
        } else if (v.order === "descending") {
          this.listParam.ascOrDesc = 'DESC'
        } else {
          this.listParam.orderBy = null
          this.listParam.ascOrDesc = null
        }

        this.selectPage(1)
      },
      formatDate(dateToFormat) {
        return utilities.formatDate(dateToFormat, 'DD/MM/YYYY')
      },
      openSearchModal() {
        this.$refs.adminSearchCaseModal.handleModal()
      },
      openSearchClaimant() {
        this.$refs.navigation.$refs.globalSearch.openSearchClaimant()
      },

      RowClick(row) {
        this.openCase(row?.id)
      },
      openCase(id) {
        this.$router.push({ name: 'admin-manage-case', query: { id: id } })
      },
      addNewCase() {
        if(this.client.id != '') {
          this.$router.push({ path:'/admin-manage-case' , query: { clientId: this.client.id } })
        } else {
          this.$router.push({ path:'/admin-manage-case' , query: {} })
        }
      },
      async searchCase(searchOption) {
        this.listParam.ClientID = searchOption.clientId
        this.listParam.ReferenceNumber = searchOption.referenceNumber
        this.listParam.ClaimantName = searchOption.claimant ? searchOption.claimant : null
        this.listParam.ClaimantFirstName = searchOption.claimantFirstname
        this.listParam.ClaimantSurname = searchOption.claimantSurname
        await this.$store.dispatch('loading/setLoadComponent', true)
        var {clientCase, total} = await utilities.getCasesNew(this.listParam)
        await this.$store.dispatch('loading/setLoadComponent', false)
        this.allCases = _.cloneDeep(clientCase)
        this.totalCount = total
        if (this.totalCount === 0) {
          this.noCaseMessage = 'No cases found.'
        } else {
          this.noCaseMessage = ''
        }
      },
      async loadClient() {
        var clientId = this.$route.query.id != undefined ? this.$route.query.id : ''
        if (clientId !== '') {
          this.$store.dispatch('loading/setLoadComponent', true)
          this.client = await utilities.getClientById(clientId)
          this.$store.dispatch('loading/setLoadComponent', false)
        }
        if (this.client.id !== '') {
          this.listParam.ClientID = this.client.id
        }
      },
      async loadData() {
        await this.$store.dispatch('loading/setLoadComponent', true)
        let obj = {...this.listParam}
        for (let key in obj) {
          if (obj[key] === null || obj[key] === '') {
            delete obj[key];
          }
        }
        const {clientCase, total} = await utilities.getCasesNew(obj)
        this.allCases = _.cloneDeep(clientCase)
        this.totalCount = total
        if (clientCase.length === 0) {
          this.noCaseMessage = 'No cases found.'
        } else {
          this.noCaseMessage = ''
        }
        await this.$store.dispatch('loading/setLoadComponent', false)
      },
    },
    async beforeMount() {
      $('body>.tooltip').remove()
      if (this.searchOptionProps !== undefined) {
        await this.searchCase(this.searchOptionProps)
      } else {
        await this.loadClient()
        await this.loadData()
      }
      this.fetchedData = true
    },
    mounted() {
      $('.pagination').hide()
    },
  }
</script>
